import { render, staticRenderFns } from "./addStock.vue?vue&type=template&id=52d156d2"
import script from "./addStock.vue?vue&type=script&lang=js"
export * from "./addStock.vue?vue&type=script&lang=js"
import style0 from "./addStock.vue?vue&type=style&index=0&id=52d156d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports